import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyDatasetDetail = lazyWithRetry(() => import("./DatasetDetail"));

const DatasetDetail = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyDatasetDetail {...props} />;

export default DatasetDetail;
